import { useSelector } from 'react-redux';
import LoginModal from './LoginModal';
import RegisterModal from './RegisterModal';
import WishlistModal from './WishlistModal';
import ShoppingCartModal from './shoppingCartModal';

const ModalContainer = () => {
  const modalType = useSelector((state: any) => state.modal.modalType);

  return (
    <>
      {modalType === 'login' && <LoginModal />}
      {modalType === 'register' && <RegisterModal />}
      {<WishlistModal />}
      {<ShoppingCartModal />}
    </>
  );
};

export default ModalContainer;
